import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';
import { CATS, Cat, Bron, Thumb, fmt } from '../components/nieuws/nieuwsUtil';

const chip = (on) => ({ padding: '6px 14px', borderRadius: 20, border: '1px solid #e5e7eb', cursor: 'pointer', background: on ? '#111827' : '#fff', color: on ? '#fff' : '#374151', fontSize: 13 });
const card = { background: '#fff', borderRadius: 14, boxShadow: '0 1px 3px rgba(0,0,0,0.06)', overflow: 'hidden' };

export default function Nieuws() {
  const nav = useNavigate();
  const { gebruiker, hasPermission } = useAuth();
  const magPlaatsen = String(gebruiker?.rol || '').toLowerCase() === 'super_admin' || hasPermission('nieuws:beheer');
  const [items, setItems] = useState([]);
  const [klein, setKlein] = useState([]);
  const [cat, setCat] = useState('');
  const [bron, setBron] = useState('alles');
  const [toonKlein, setToonKlein] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([api.get('/nieuws'), api.get('/changelog').catch(() => ({ data: { items: [] } }))])
      .then(([n, c]) => { setItems(n.data.items || []); setKlein(c.data.items || []); })
      .catch(() => {}).finally(() => setLoading(false));
    api.post('/nieuws/gezien').catch(() => {});
  }, []);

  const lijst = useMemo(() => items.filter((n) => (!cat || n.categorie === cat) && (bron === 'alles' || (bron === 'womsys' ? !n.bedrijf_id : !!n.bedrijf_id))), [items, cat, bron]);
  const [hero, ...rest] = lijst;
  const bedrijfNaam = items.find((n) => n.bedrijf_id)?.bedrijf_naam;

  return (
    <div className="nieuws-page">
      <div className="page-header">
        <div className="page-header-left">
          <h1>📰 Nieuws</h1>
          <span className="welcome-text">Updates van WOMsys{bedrijfNaam ? ` en berichten van ${bedrijfNaam}` : ''}.</span>
        </div>
        {magPlaatsen && <div className="page-header-right"><button onClick={() => nav('/nieuw/beheer')} style={{ background: '#3b82f6', color: '#fff', border: 'none', borderRadius: 10, padding: '10px 18px', fontWeight: 600, cursor: 'pointer' }}>+ Bericht plaatsen</button></div>}
      </div>

      <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 22, flexWrap: 'wrap' }}>
        <button onClick={() => setCat('')} style={chip(!cat)}>Alles</button>
        {Object.entries(CATS).map(([k, v]) => <button key={k} onClick={() => setCat(k)} style={chip(cat === k)}>{v.label}</button>)}
        <span style={{ flex: 1 }} />
        <div style={{ display: 'flex', background: '#e5e7eb', borderRadius: 20, padding: 3, fontSize: 12 }}>
          {[['alles', 'Alles'], ['womsys', 'WOMsys'], ['bedrijf', bedrijfNaam || 'Bedrijf']].map(([k, l]) => (
            <span key={k} onClick={() => setBron(k)} style={{ padding: '4px 12px', borderRadius: 16, cursor: 'pointer', background: bron === k ? '#fff' : 'transparent', color: bron === k ? '#111827' : '#6b7280', fontWeight: bron === k ? 600 : 400 }}>{l}</span>
          ))}
        </div>
      </div>

      {loading ? <p style={{ color: '#6b7280' }}>Laden…</p> : !hero ? (
        <div style={{ ...card, padding: 40, textAlign: 'center', color: '#6b7280' }}>Nog geen berichten.</div>
      ) : (
        <>
          <div onClick={() => nav(`/nieuw/${hero.id}`)} style={{ ...card, display: 'grid', gridTemplateColumns: '1.2fr 1fr', marginBottom: 20, cursor: 'pointer' }}>
            <Thumb n={hero} height={320} fontSize={90} />
            <div style={{ padding: '30px 32px', display: 'flex', flexDirection: 'column' }}>
              <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}><Cat c={hero.categorie} /><Bron n={hero} /></div>
              <h2 style={{ fontSize: 27, margin: '14px 0 10px', lineHeight: 1.2 }}>{hero.titel}</h2>
              <p style={{ color: '#4b5563', fontSize: 15, lineHeight: 1.6, margin: 0 }}>{hero.intro}</p>
              <div style={{ marginTop: 'auto', paddingTop: 14, display: 'flex', gap: 12, color: '#9ca3af', fontSize: 13 }}>
                <span>{fmt(hero.publicatie_datum)}</span><span>·</span><span>{hero.auteur_voornaam}</span>
                <span style={{ marginLeft: 'auto', color: '#3b82f6', fontWeight: 600 }}>Lees verder →</span>
              </div>
            </div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16, marginBottom: 30 }}>
            {rest.map((n) => (
              <div key={n.id} onClick={() => nav(`/nieuw/${n.id}`)} style={{ ...card, display: 'flex', flexDirection: 'column', cursor: 'pointer' }}>
                <div style={{ position: 'relative' }}><Thumb n={n} />{n.bedrijf_id && <span style={{ position: 'absolute', top: 10, left: 10 }}><Bron n={n} /></span>}</div>
                <div style={{ padding: '16px 18px 14px', display: 'flex', flexDirection: 'column', flex: 1 }}>
                  <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}><Cat c={n.categorie} />{!n.bedrijf_id && <Bron n={n} />}</div>
                  <h3 style={{ fontSize: 16, margin: '10px 0 6px', lineHeight: 1.3 }}>{n.titel}</h3>
                  <p style={{ color: '#4b5563', fontSize: 14, lineHeight: 1.5, margin: '0 0 10px' }}>{n.intro}</p>
                  <div style={{ marginTop: 'auto', color: '#9ca3af', fontSize: 13 }}>{fmt(n.publicatie_datum)}</div>
                </div>
              </div>
            ))}
          </div>
        </>
      )}

      {klein.length > 0 && (
        <div>
          <h4 onClick={() => setToonKlein((v) => !v)} style={{ margin: '0 0 12px', fontSize: 12, color: '#6b7280', textTransform: 'uppercase', letterSpacing: 1, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8 }}>
            Ook verbeterd <span style={{ background: '#e5e7eb', color: '#374151', borderRadius: 10, padding: '1px 8px', fontSize: 11 }}>{klein.length}</span>
            <span style={{ fontSize: 11 }}>{toonKlein ? '▲' : '▼'}</span>
          </h4>
          {toonKlein && (
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
              {klein.map((it) => (
                <div key={`${it.type}-${it.id}`} style={{ ...card, padding: '12px 16px', display: 'flex', gap: 12 }}>
                  <span>{it.type === 'idee' ? '💡' : '✨'}</span>
                  <div><div style={{ fontWeight: 600, fontSize: 14 }}>{it.titel}</div><div style={{ color: '#9ca3af', fontSize: 12, marginTop: 2 }}>{it.type === 'idee' ? 'Idee gemaakt · ' : ''}{fmt(it.datum)}</div></div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
